import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FileSignature } from '../../types/file-signature';
import { Subscription } from 'rxjs';
import { FileService } from '../../service/file.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-verify-signature',
  imports: [],
  templateUrl: './verify-signature.component.html',
  styleUrl: './verify-signature.component.scss'
})
export class VerifySignatureComponent implements OnInit, OnDestroy {
  containerName: string | null = null;
  signature: string | null = null;
  targetFileGuid: string | null = null;
  resultText: string | null = null;

  private _subscription: Subscription;
  private _fileService = inject(FileService);
  private _router = inject(Router);
  constructor(
  ) {
    const urlParams = new URLSearchParams(window.location.search);
    this.containerName = urlParams.get('containerName');
    this.signature = urlParams.get('signature');
    this.targetFileGuid = urlParams.get('fileGuid');
    this._subscription = new Subscription();
  }

  ngOnInit(): void {
    this.checkParameters();
    this.getFileInfo();
    this._fileService.updateFileStoreSignature(this.signature || '');
    this._fileService.updateFileStoreContainerName(this.containerName || '');
    this._fileService.updateFileStoreFileGuid(this.targetFileGuid || '');
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  // クエリパラメーターの値をチェックする
  checkParameters() {
    if (!this.containerName || !this.signature) {
      // シグネチャ不正画面に遷移する
      this._router.navigate(['/error/invalid-signature']);
    }
    else {
      this.resultText = 'ファイル情報を取得中...';
    }
  }

  // signatureがnullでない場合、ファイルダウンロードの処理を行う
  getFileInfo() {
    if (this.signature && this.containerName) {
      this._subscription.add(
        this._fileService.getFileInfoBySignature(this.containerName, this.signature).subscribe({
          next: (fileSignature: FileSignature) => {
            // アクセスコードの入力を促す
            this._fileService.updateFileStoreFileSignatureInfo(fileSignature);
            if (!fileSignature.isUseAccessCode) {
              // /download に遷移する
              this.resultText = 'ファイル情報を取得しました。ダウンロードを開始します。';
              this._router.navigate(['/download']);
            } else {
              // アクセスコード入力画面に遷移する
              this.resultText = 'ファイル情報を取得しました。アクセスコードを入力してください。';
              this._router.navigate(
                ['/access-code-validation'],
                { queryParams: { containerName: this.containerName, fileGuid: this.targetFileGuid, signature: this.signature } }
              );
            }
          },
          error: (error: HttpErrorResponse) => {
            console.error('Error retrieving file info:', error);
            this.resultText = 'ファイル情報の取得に失敗しました。';
            this.navigeteForValidarion(error.error as FileSignature, error.status);
          }
        })
      );
    }
  }

  navigeteForValidarion(result: FileSignature, status: number) {
    if (status === 410) {
      this._router.navigate(['/error/expired']);
      return;
    }
    if (!result.isVerifiedSignature) {
      // シグネチャ不正画面に遷移する
      this._router.navigate(['/error/invalid-signature']);
      return
    }
    if (result.isExpiredUrl) {
      // 有効期限切れ画面に遷移する
      this._router.navigate(['/error/expired']);
      return;
    }
    if (result.isLockedAccess) {
      // アクセス制限画面に遷移する
      this._router.navigate(['/error/lock']);
      return;
    }
    if (result.isManualDelete) {
      // 手動削除画面に遷移する
      this._router.navigate(['/error/invalid-url']);
      return;
    }
  }
}
